import Vue from 'vue';
import { i18n } from '@/plugins/vue-i18n';
import {
  Actions, chip, flag, metadata, tooltip,
} from '@/modules/list/config/utils';
import store from '@/store';

export default function (board) {
  let metaStatus = null;
  if (board.scheduled) {
    metaStatus = i18n.t('message.metadata.status.scheduled');
  } else if (board.published) {
    metaStatus = i18n.t('message.metadata.published');
  } else {
    metaStatus = i18n.t('message.metadata.draft');
  }

  let publishedMetaLabel = 'publishDate';
  let publishedMetaValue = null;
  if (board.published) {
    if (board.firstPublicationDate) {
      publishedMetaLabel = i18n.t('message.metadata.firstPublicationDate');
      publishedMetaValue = Vue.filter('formatDate')(board.firstPublicationDate);
    } else {
      publishedMetaLabel = i18n.t('message.metadata.publishedDate');
      publishedMetaValue = Vue.filter('formatDate')(board.publishedDate);
    }
  }

  const site = store.getters.getSiteFromSiteId(board.siteId);

  return {
    id: board.id,
    title: board.title,
    icon: {
      name: 'dashboard',
    },
    type: 'board',
    editor: 'board',
    url: board.publicUrl,
    flag: flag(board),
    chips: [
      tooltip(chip(Vue.filter('formatDate')(board.creationDate)), i18n.t('message.metadata.creationDate')),
      tooltip(chip(board.published ? i18n.t('message.content.status.published') : null), i18n.t('message.metadata.status')),
      tooltip(chip(!board.published ? i18n.t('message.content.status.draft') : null), i18n.t('message.metadata.draft')),
      tooltip(chip(board.behaviour ? i18n.t(`message.board.behaviour.${board.behaviour}`) : null), i18n.t('message.metadata.type')),
    ].filter(c => !!c.value),
    metadata: [
      metadata('ID', board.id),
      metadata(i18n.t('message.metadata.status'), metaStatus),
      metadata(publishedMetaLabel, publishedMetaValue),
      metadata(i18n.t('message.metadata.publicUrl'), board.published && board.publicUrl ? board.publicUrl : null, true),
      metadata(i18n.t('message.metadata.createdBy'), board.creationStaffId ? board.creationStaffId.nick : null),
      metadata(i18n.t('message.metadata.creationSite'), site ? site.name : null),
      metadata(i18n.t('message.metadata.creationDate'), Vue.filter('formatDate')(board.creationDate)),
      board.published
        ? metadata(
          board.lastPublicationDate ? i18n.t('message.metadata.lastPublicationDate') : i18n.t('message.metadata.publishedDate'),
          board.lastPublicationDate ? Vue.filter('formatDate')(board.lastPublicationDate) : Vue.filter('formatDate')(board.publishedDate),
        )
        : metadata(
          i18n.t('message.metadata.lastModifiedDate'),
          Vue.filter('formatDate')(board.modificationDate),
        ),
      metadata(i18n.t('message.metadata.lastModifiedBy'), board.lastModificationStaffId ? board.lastModificationStaffId.nick : null),
    ],
    actions: [
      Actions.METADATA,
      Actions.LINK,
    ],
  };
}
